module.exports = __webpack_public_path__ + "static/media/maria.fe4f4316.jpg";